e4.gtm = {
    pushDataLayer: function ( objDataLayer ) {
        if ( window.google_tag_manager !== undefined && window.dataLayer !== undefined ) {
            dataLayer.push( objDataLayer );
        }
    }
};

